export const COMPANY_NOT_FOUND = 'Company not found';
export const SELECT_A_COMPANY = 'Select a Company';
